import React, { useEffect, useState } from "react";
import { Modal, notification } from "antd";
import { Button } from "react-bootstrap";
import QRCode from "react-qr-code";
import { initSharedWorker, connectSocket, disconnectSocket, sendJoinRoom, registerCallbackForSocketEvent } from "./../../../sharedSocket/sharedSocket";
import { generateUUID, getTokenLocalStorage, onScannedProducts } from "../Common/utils";
import { useRef } from "react";
import {
  ScanOutlined
} from '@ant-design/icons'
import "./socket-style.css";

const SocketConfigurationButton = ({ style = {}, buttonStyle = {} }) => {
  const [connected, setConnected] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [wantJoinRoom, setWantJoinRoom] = useState(false);
  const [confirmDisconnected, setConfirmDisconnected] = useState(false);
  const [uuid, setUUID] = useState(null);
  const containerRef = useRef(null);
  const isDragging = useRef(false);
  const startY = useRef(0);
  const startTop = useRef(0);
  let systemUser = "";
  const token = getTokenLocalStorage();
  const socketUrl = `wss://${window.location.hostname}`
  // const socketUrl = `wss://preprod.ikhub.biz`

  const handleSocketEvents = (event) => {
    if (event.type === "WSState") {
      if (event.data.state === "connected") {
        setConnected(true);

        systemUser = event.data.socketId;

        if (!localStorage.getItem("uuid")) {
          const newUUID = generateUUID();
          setUUID(newUUID);
          localStorage.setItem("uuid", newUUID);
          setIsVisible(true);
          notification.success({ message: "Connection created successfully!" });
        } else {
          setUUID(localStorage.getItem("uuid"))
        }

        sendJoinRoom({ room_id: localStorage.getItem("uuid") });
      } else if (event.data?.state == "disconnected") {
        if (event?.data?.data) {
          notification.error({ message: "User disconnected!" });
        }
        localStorage.removeItem("uuid");
        setUUID(null);
        localStorage.removeItem("user_joined");
        setConnected(false);
      }
    } else if (event.type === "user_left") {
      localStorage.removeItem("user_joined");
      setIsVisible(true);
    } else if (event.type === "scan_result_raw") {
      onScannedProducts(event.data.scan_keys);
    } else if (event.type === "user_joined") {
      const currentUserId = event?.data?.user;
      const myUUID = localStorage.getItem("uuid");
      if (!currentUserId) {
        console.warn("⚠️ user_joined event has no user ID");
        return;
      }

      if (currentUserId === systemUser || currentUserId === myUUID) {
        console.log("👤 Skipping own join (system)");
        return;
      }

      setIsVisible(false);
      localStorage.setItem("user_joined", "true");
      notification.success({ message: "User connected successfully!" });
      console.log("✅ First external user joined:", currentUserId);
    } else {
      console.log("ℹ️ Another user joined — already handled once.");
    }
    // }
  };

  useEffect(() => {
    initSharedWorker();

    if (localStorage.getItem("uuid")) {
      connectSocket(token, socketUrl);
    }
    // Listen for socket events
    registerCallbackForSocketEvent(handleSocketEvents);
    return () => {
      console.log("🧹 Cleaning up socket event listeners");
      // Cleanup logic if needed
      disconnectSocket();
    };
  }, []);
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging.current || !containerRef.current) return;
      const dy = e.clientY - startY.current;
      const newTop = Math.max(0, startTop.current + dy);
      containerRef.current.style.top = `${newTop}px`;
    };

    const handleMouseUp = () => {
      isDragging.current = false;
      document.body.style.cursor = "default";
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const startDragging = (e) => {
    if (!containerRef.current) return;
    isDragging.current = true;
    startY.current = e.clientY;
    startTop.current = containerRef.current.getBoundingClientRect().top;
    document.body.style.cursor = "grabbing";
  };

  return (
    <div
    >
      <div id="socket-connector" className={`float-container ${connected ? "danger-background-color" : "primary-background-color"}`} ref={containerRef}>
        <div
          style={{
            alignContent: "center",
            height: "40px",
          }}
        >
          <div className="drag-handle" onMouseDown={startDragging} title="Drag">
            <ScanOutlined style={{ marginBottom: "7px", fontSize: "17px" }} />
          </div>
        </div>
        <div>
          <button
            style={buttonStyle}
            disabled={isVisible}
            className="icon one socket-button btn"
            onClick={() => {
              if (connected) {
                if (!localStorage.getItem("user_joined")) {
                  setWantJoinRoom(true);
                } else {
                  setConfirmDisconnected(true);
                }
              } else {
                localStorage.removeItem("uuid");
                setUUID(null);
                connectSocket(token, socketUrl);
              }
            }}
          >
            {connected ? "Disconnect khub scanner" : "Connect to khub scanner"}
          </button>
        </div>
      </div>

      <Modal title={null} visible={isVisible} onCancel={() => setIsVisible(false)} footer={null} centered>
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          <QRCode value={JSON.stringify({ room_id: uuid })} size={180} />
          <p style={{ marginTop: 16 }}>Scan this QR to connect via another device</p>
        </div>
      </Modal>

      <Modal
        title="Are you sure?"
        visible={confirmDisconnected}
        onCancel={() => {
          setConfirmDisconnected(false);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setConfirmDisconnected(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="disconnect"
            variant="danger"
            onClick={() => {
              setConnected(false);
              setConfirmDisconnected(false);
              disconnectSocket();
            }}
          >
            Disconnect
          </Button>,
        ]}
        centered
      >
        <p style={{ marginLeft: "25px" }}>You want to disconnect the scanner?</p>
      </Modal>

      <Modal
        title="Choose an Action"
        visible={wantJoinRoom}
        onCancel={() => setWantJoinRoom(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setWantJoinRoom(false);
              setIsVisible(true);
            }}
          >
            Connect Scanner
          </Button>,
          <Button
            key="disconnect"
            variant="danger"
            onClick={() => {
              setWantJoinRoom(false);
              setConnected(false);
              setConfirmDisconnected(false);
              disconnectSocket();
            }}
          >
            Disconnect
          </Button>,
        ]}
        centered
      >
        <p style={{ marginLeft: "25px" }}>Do you want to connect the scanner or disconnect from the scanner?</p>
      </Modal>
    </div>
  );
};

export default SocketConfigurationButton;
